import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, ApiModels } from '@mona/api';
import { Anamnesis, Encounter } from '@mona/models';
import { transformApiAnamneses } from './transforms';

/**
 * API abstraction layer for the anamneses API
 */
@Injectable({
    providedIn: 'root',
})
export class AnamnesesApi {
    apiBase = '/pdms/anamneses/';

    /**
     * Constructor
     * @param http HttpClient
     */
    constructor(private http: HttpService) {}

    /**
     * Get anamneses
     * @param encounterId
     */
    getAnamneses(encounterId?: EntityId<Encounter>): Observable<Anamnesis[]> {
        const params: {
            [param: string]: string | string[];
        } = {};

        if (encounterId) {
            params.encounter_id = `${encounterId}`;
        }

        return this.http
            .get<ApiModels.Anamnesis[]>(this.apiBase, {
                params,
            })
            .pipe(map(anamneses => transformApiAnamneses(anamneses)));
    }
}
